import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconSqualls: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M53.2442 67.8889L48.3887 81.2111H53.122L57.9665 67.8889H53.2442Z"
        fill="#87D6F8"
      />
      <path
        d="M33.8885 67.8889L32.2773 72.3223H37.0107L38.6218 67.8889H33.8885Z"
        fill="#87D6F8"
      />
      <path
        d="M43.5675 67.8889L41.9453 72.3223H46.6786L48.2898 67.8889H43.5675Z"
        fill="#87D6F8"
      />
      <path
        d="M40.3338 76.8L38.7227 81.2223H43.4449L45.056 76.8H40.3338Z"
        fill="#87D6F8"
      />
      <path
        d="M65.5127 47.1203L61.0314 47.0105L60.9227 42.4818C60.7054 33.3969 52.8835 26 43.5 26C40.8791 26 38.3669 26.5764 36.0855 27.6331C32.3782 29.3348 29.3228 32.299 27.5982 36.1004L26.5389 38.4334L24.0267 38.8176C18.4862 39.6685 14.1543 43.9364 13.2037 49.1788C13.0815 49.8787 13 50.606 13 51.3333C13 58.3185 18.8664 64 26.0637 64H65.2818C70.089 64 74 60.2123 74 55.5601C74.0135 51.0177 70.1976 47.23 65.5127 47.1203Z"
        fill="#87D6F8"
      />
      <path
        d="M81.5215 27.3368L79.6899 27.2899L79.6417 25.5068C79.5533 21.9171 76.348 19 72.5 19C71.4316 19 70.3952 19.2268 69.4634 19.6413C67.9451 20.3139 66.6918 21.487 65.9849 22.9885L65.5511 23.9114L64.5228 24.06C62.2574 24.3962 60.482 26.0855 60.0884 28.1502C60.0321 28.4317 60 28.7132 60 29.0026C60 31.7555 62.402 34 65.3583 34H81.4251C83.3933 34 85 32.5063 85 30.6684C85 28.8775 83.4415 27.3837 81.5215 27.3368Z"
        fill="#87D6F8"
      />
    </svg>
  )
}

export default WeatherIconSqualls
